import { SubscriptionGifts } from "@/forms/subscription/SubscriptionGifts";
import { SubscriptionGiftSections } from "@/forms/subscription/SubscriptionGiftSections";
import { SubscriptionOrder } from "./SubscriptionOrder";
import { useFormContext, useWatch } from "react-hook-form";
import { SubscriptionProduct } from "@cappelendamm/e-commerce-services";
import { CheckoutForm } from "@/checkout/types";
import { Suspense } from "react";
import LoadingPlaceholder from "@/components/LoadingPlaceholder";
import { BookSelector } from "@/forms/subscription/BookSelector";
import { CampaignBooks } from "@/forms/subscription/CampaignBooks";

export type SubscriptionSectionProps = {
  subscription: SubscriptionProduct;
  isPending?: boolean;
  hideGiftSelection?: boolean;
};

export const SubscriptionSection = ({
  subscription,
  isPending,
  hideGiftSelection = false,
}: SubscriptionSectionProps) => {
  const form = useFormContext<CheckoutForm>();
  const gifts = useWatch({ control: form.control, name: "gifts" });
  const giftSections =
    useWatch({ control: form.control, name: "giftSections" }) ?? [];

  const isCampaignBooksAvailable =
    subscription.campaignBooks && subscription.campaignBooks.length > 0;

  return (
    <fieldset
      className="grid justify-items-stretch space-y-4"
      data-testid="order-step"
      disabled={isPending}
    >
      <legend className="sr-only">Din bestilling</legend>

      <div className="space-y-9">
        <SubscriptionOrder subscription={subscription} />

        {subscription.isSeries && !isCampaignBooksAvailable ? (
          <Suspense fallback={<LoadingPlaceholder />}>
            <BookSelector subscription={subscription} />
          </Suspense>
        ) : null}

        {isCampaignBooksAvailable ? (
          <CampaignBooks campaignBooks={subscription.campaignBooks} />
        ) : null}
      </div>

      {!hideGiftSelection && giftSections.length > 0 ? (
        <SubscriptionGiftSections isPending={isPending} />
      ) : null}

      {!hideGiftSelection &&
      !giftSections.length &&
      gifts &&
      gifts.length > 0 ? (
        <SubscriptionGifts
          count={subscription.gifts.count}
          items={gifts}
          fieldArrayName="gifts"
        />
      ) : null}
    </fieldset>
  );
};
